export default {
  title: {
    en: 'Shop best sellers',
  },
  // TODO seems a very common pattern - added on 04.02.2022 by sonatskiy
  perfumes: {
    en: 'Perfumes',
  },
  colognes: {
    en: 'Colognes',
  },
}
